import styled from 'styled-components';
import { getTextTokenPreset, getToken } from '@optimus-web/common';

export const Affix = styled.div<{ $disabled?: boolean }>`
    ${getTextTokenPreset('bodyMedium')};
    color: ${({ $disabled }) => ($disabled ? getToken('textDisabled') : getToken('textStaticSecondary'))};
`;
